import { render } from "./TopbarTopDog.vue?vue&type=template&id=578c60b8"
import script from "./TopbarTopDog.vue?vue&type=script&lang=js"
export * from "./TopbarTopDog.vue?vue&type=script&lang=js"

import "./TopbarTopDog.vue?vue&type=style&index=0&id=578c60b8&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/TopbarTopDog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "578c60b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('578c60b8', __exports__)) {
    console.log('reload')
    api.reload('578c60b8', __exports__)
  }
  
  module.hot.accept("./TopbarTopDog.vue?vue&type=template&id=578c60b8", () => {
    console.log('re-render')
    api.rerender('578c60b8', render)
  })

}


export default __exports__